import React from "react";
import {Button} from "../../components/core/Button.jsx";
import {Icon} from "../../components/core/Icon.jsx";
import {Badge} from "../../components/core/Badge.jsx";

export const MAX={maxWidth:"var(--container-max)",margin:"0 auto",padding:"0 clamp(20px,5vw,56px)"};
export const H1="clamp(34px,6.2vw,62px)";
export const H2="clamp(26px,3.6vw,38px)";

export function Wordmark({invert=false,small=false}){
  return (
    <div style={{display:"flex",alignItems:"center",gap:12,lineHeight:1}}>
      <img src="/assets/logo.png" alt="Dental Project" width={small?36:44} height={small?36:44} style={{width:small?36:44,height:small?36:44,flex:"0 0 auto",borderRadius:"50%",background:invert?"transparent":"var(--teal-900)"}}/>
      <div style={{lineHeight:1}}>
      <div style={{fontFamily:"var(--font-display)",fontWeight:800,fontSize:small?18:22,letterSpacing:"-.035em",color:invert?"#fff":"var(--teal-900)"}}>Dental Project</div>
      <div style={{fontFamily:"var(--font-signature)",fontSize:small?15:17,color:invert?"var(--cyan-300)":"var(--cyan-700)",marginTop:2}}>by Borja Mendoza</div>
      </div>
    </div>
  );
}

const NAV=[["home","Laboratorio"],["servicios","Servicios"],["agentes","Agentes IA"],["casos","Casos"],["contacto","Contacto"]];

export function SiteHeader({route,go}){
  const [open,setOpen]=React.useState(false);
  const pick=r=>{setOpen(false);go(r)};
  return (
    <header style={{position:"sticky",top:0,zIndex:30,background:"rgba(248,250,250,.92)",backdropFilter:"blur(10px)",borderBottom:"1px solid var(--line-hairline)"}}>
      <div style={{...MAX,minHeight:76,display:"flex",alignItems:"center",gap:24}}>
        <a href="/" onClick={e=>{e.preventDefault();pick("home")}} style={{border:"none"}}><Wordmark/></a>
        <nav className="dp-navlinks">
          {NAV.map(([r,l])=>(
            <a key={r} href={r==="home"?"/":"/"+r+"/"} onClick={e=>{e.preventDefault();pick(r)}}
              style={{border:"none",fontFamily:"var(--font-display)",fontSize:14,fontWeight:600,letterSpacing:".01em",
                color:route===r?"var(--fg-1)":"var(--fg-2)",borderBottom:"2px solid "+(route===r?"var(--cyan-500)":"transparent"),paddingBottom:4}}>{l}</a>
          ))}
        </nav>
        <div className="dp-hidesm" style={{marginLeft:"auto"}}>
          <Button variant="accent" iconRight={<Icon name="arrow-right" size={15}/>} onClick={()=>pick("contacto")}>Enviar un caso</Button>
        </div>
        <button className="dp-burger" aria-label={open?"Cerrar menú":"Abrir menú"} aria-expanded={open} onClick={()=>setOpen(o=>!o)}
          style={{marginLeft:"auto",cursor:"pointer",width:44,height:44,padding:0,background:"none",
            alignItems:"center",justifyContent:"center",borderRadius:"var(--radius-2)",
            border:"1px solid var(--line-default)",color:"var(--fg-1)"}}>
          <Icon name={open?"x":"menu"} size={20} strokeAlign="middle"/>
        </button>
      </div>
      {open&&(
        <nav style={{borderTop:"1px solid var(--line-hairline)",background:"var(--surface-card)",padding:"8px clamp(20px,5vw,56px) 20px",display:"flex",flexDirection:"column"}}>
          {NAV.map(([r,l])=>(
            <a key={r} href={r==="home"?"/":"/"+r+"/"} onClick={e=>{e.preventDefault();pick(r)}}
              style={{border:"none",borderBottom:"1px solid var(--line-hairline)",padding:"14px 0",minHeight:48,display:"flex",alignItems:"center",
                fontFamily:"var(--font-display)",fontSize:17,fontWeight:600,color:route===r?"var(--fg-brand)":"var(--fg-1)"}}>{l}</a>
          ))}
          <Button variant="accent" size="lg" fullWidth style={{marginTop:16}} onClick={()=>pick("contacto")}>Enviar un caso</Button>
        </nav>
      )}
    </header>
  );
}

/* Columnas del pie. `route` navega dentro del sitio; `href` abre correo o teléfono; sin ninguno, es solo texto. */
const FOOTER=[
  ["Laboratorio",[
    {label:"Servicios y materiales",route:"servicios"},
    {label:"Flujo digital",route:"home"},
    {label:"Casos",route:"casos"},
    {label:"Enviar un caso",route:"contacto"}
  ]],
  ["Automatización",[
    {label:"Agentes de IA",route:"agentes"},
    {label:"Cómo funciona un Agente",route:"agentes"},
    {label:"Para otros laboratorios",route:"agentes"}
  ]],
  ["Contacto",[
    {label:"dentalproject404@gmail.com",href:"mailto:dentalproject404@gmail.com"},
    {label:"+34 666 828 334",href:"tel:+34666828334"},
    {label:"Jerez de la Frontera, Cádiz"}
  ]]
];

function FooterLink({item,go}){
  const [hover,setHover]=React.useState(false);
  const style={fontSize:14,color:hover?"#fff":"var(--neutral-300)",border:"none",
    borderBottom:"1px solid "+(hover?"var(--cyan-500)":"transparent"),paddingBottom:1,
    transition:"var(--transition-control)",display:"inline-block"};
  const bind={onMouseEnter:()=>setHover(true),onMouseLeave:()=>setHover(false)};
  if(item.route) return <a href={item.route==="home"?"/":"/"+item.route+"/"} onClick={e=>{e.preventDefault();go(item.route)}} style={style} {...bind}>{item.label}</a>;
  if(item.href) return <a href={item.href} style={style} {...bind}>{item.label}</a>;
  return <span style={{fontSize:14,color:"var(--neutral-300)"}}>{item.label}</span>;
}

export function SiteFooter({go}){
  return (
    <footer style={{background:"var(--teal-900)",color:"var(--neutral-200)",paddingTop:64,paddingBottom:32,backgroundImage:"var(--pattern-grid-on-brand)"}}>
      <div className="dp-footer" style={{...MAX,gap:32}}>
        <div><Wordmark invert/>
          <p style={{fontSize:14,lineHeight:1.6,color:"var(--neutral-300)",marginTop:18,maxWidth:"32ch"}}>Laboratorio de prótesis dental con flujo digital completo. Jerez de la Frontera.</p>
        </div>
        {FOOTER.map(([t,items])=>(
          <div key={t}>
            <div style={{fontFamily:"var(--font-display)",fontSize:11,fontWeight:600,letterSpacing:".12em",textTransform:"uppercase",color:"var(--cyan-300)"}}>{t}</div>
            <ul style={{listStyle:"none",padding:0,margin:"14px 0 0",display:"flex",flexDirection:"column",gap:9}}>
              {items.map(i=><li key={i.label}><FooterLink item={i} go={go}/></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div style={{...MAX,marginTop:56,paddingTop:20,borderTop:"1px solid var(--line-on-brand)",display:"flex",flexWrap:"wrap",gap:8,justifyContent:"space-between"}}>
        <span style={{fontFamily:"var(--font-mono)",fontSize:11,color:"var(--neutral-400)"}}>© 2026 Dental Project</span>
        <span style={{fontFamily:"var(--font-mono)",fontSize:11,color:"var(--neutral-400)",display:"flex",gap:12}}>
          <a href="/aviso-legal/" style={{color:"var(--neutral-400)"}}>Aviso legal</a>
          <a href="/privacidad/" style={{color:"var(--neutral-400)"}}>Privacidad</a>
        </span>
      </div>
    </footer>
  );
}

export function Section({tone="page",children,style}){
  const bg=tone==="brand"?{background:"var(--teal-700)",color:"#fff",backgroundImage:"var(--pattern-grid-on-brand)"}
    :tone==="card"?{background:"var(--surface-card)"}:{background:"var(--surface-page)"};
  return <section style={{paddingTop:"clamp(56px,9vw,96px)",paddingBottom:"clamp(56px,9vw,96px)",borderTop:"1px solid var(--line-hairline)",...bg,...style}}>
    <div style={MAX}>{children}</div>
  </section>;
}

export function Eyebrow({children,invert=false}){
  return <div style={{fontFamily:"var(--font-display)",fontSize:12,fontWeight:600,letterSpacing:".14em",textTransform:"uppercase",color:invert?"var(--cyan-300)":"var(--cyan-700)"}}>{children}</div>;
}

/** Hueco de imagen: no se aportó fotografía con esta marca. */
export function Placeholder({label,ratio="4 / 3",tone="light",style}){
  const dark=tone==="dark";
  return <div style={{aspectRatio:ratio,borderRadius:"var(--radius-photo)",display:"flex",alignItems:"flex-end",padding:16,
    background:dark?"var(--teal-800)":"var(--neutral-100)",backgroundImage:dark?"var(--pattern-grid-on-brand)":"var(--pattern-grid)",
    border:"1px solid "+(dark?"var(--teal-700)":"var(--line-default)"),...style}}>
    <span style={{fontFamily:"var(--font-mono)",fontSize:11,color:dark?"var(--cyan-300)":"var(--fg-3)"}}>{label}</span>
  </div>;
}

/** Retrato de Borja recortado sobre fondo negro de estudio. */
export function Portrait({ratio="4 / 4.4",style}){
  return <div style={{aspectRatio:ratio,borderRadius:"var(--radius-photo)",background:"#000",overflow:"hidden",display:"flex",alignItems:"flex-end",justifyContent:"center",...style}}>
    <img src="/assets/borja-retrato.jpeg" alt="Borja Mendoza, protésico dental" style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"center top",display:"block"}}/>
  </div>;
}

/* Sentido del desplazamiento, compartido por todos los Reveal. */
let dpDir="down";
if(typeof window!=="undefined"){
  let last=window.scrollY;
  window.addEventListener("scroll",()=>{const y=window.scrollY;if(Math.abs(y-last)>2){dpDir=y>last?"down":"up";last=y}},{passive:true});
}

/** Aparece cada vez que entra en pantalla, viniendo del lado por el que se desplaza (o del lado fijo de `dir`). */
export function Reveal({as="div",delay=0,dir,children,style,...rest}){
  const ref=React.useRef(null);
  const [from,setFrom]=React.useState(dir||"down");
  const [seen,setSeen]=React.useState(false);
  React.useEffect(()=>{
    const el=ref.current;if(!el)return;
    const io=new IntersectionObserver(es=>{
      es.forEach(e=>{
        if(e.isIntersecting){setFrom(dir||dpDir);setSeen(true)}
        else setSeen(false);   /* se rearma: vuelve a entrar al pasar de nuevo, suba o baje */
      });
    },{threshold:.12,rootMargin:"0px 0px -6% 0px"});
    io.observe(el);
    return ()=>io.disconnect();
  },[dir]);
  const Tag=as;
  return <Tag ref={ref} data-from={from} className={"dp-reveal"+(seen?" in":"")}
    style={{transitionDelay:delay?delay+"ms":undefined,...style}} {...rest}>{children}</Tag>;
}

/** Palabra con desajuste de canal. Parpadea al entrar y luego cada ~3 s, con desfase.
 *  `loud`: version mas intensa y mas frecuente, solo para el reclamo puntual
 *  de la guia gratis - a proposito distinta del resto, no cuenta contra el
 *  maximo de 5 Glitch por pagina de las guidelines de marca. */
export function Glitch({children,loud=false}){
  const ref=React.useRef(null);
  const [on,setOn]=React.useState(false);
  /* El texto de los canales desplazados se lee del propio nodo: así siempre coincide. */
  React.useEffect(()=>{const el=ref.current;if(el)el.setAttribute("data-text",el.textContent||"")},[children]);
  React.useEffect(()=>{
    let t1,t2,alive=true;
    const holdMs=loud?1500:1100;
    const gapBase=loud?700:2000;
    const gapRand=loud?600:900;
    const fire=()=>{
      if(!alive)return;
      setOn(true);
      t1=setTimeout(()=>{setOn(false);t2=setTimeout(fire,gapBase+Math.random()*gapRand)},holdMs);
    };
    t2=setTimeout(fire,300);
    return ()=>{alive=false;clearTimeout(t1);clearTimeout(t2)};
  },[loud]);
  return <span ref={ref} className={"dp-glitch"+(loud?" loud":"")+(on?" on":"")}><span>{children}</span></span>;
}

/** Los medios de un caso (assets/casos/**) se cachean 1 semana en el navegador
 *  (ver nginx) pero se reescriben con el mismo nombre de archivo cuando se
 *  actualiza un caso; sin version en la URL, un visitante que ya cargo la
 *  pagina se queda con el archivo viejo hasta que expire la cache. */
export function withVersion(url){
  if(!url || !(url.startsWith("/assets/casos/")||url==="/assets/qr-scan-caja.jpg")) return url;
  const v = typeof process!=="undefined" && process.env && process.env.DP_BUILD_ID;
  if(!v) return url;
  return url+(url.includes("?")?"&":"?")+"v="+v;
}

/** Foto del laboratorio sobre fondo oscuro. */
export function Photo({src,alt,ratio="4 / 3",fit="cover",style}){
  /* fit="contain" muestra la foto entera; el fondo negro coincide con el de las fotos, así no se notan bandas. */
  return <div style={{aspectRatio:ratio,borderRadius:"var(--radius-photo)",background:"#000",overflow:"hidden",...style}}>
    <img src={withVersion(src)} alt={alt} loading="lazy" decoding="async" style={{width:"100%",height:"100%",objectFit:fit,display:"block"}}/>
  </div>;
}
